/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var RequisitionsIcon = createIcon("RequisitionsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5c-1.103 0-2 .897-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.113 22H5.887A.887.887 0 015 21.113V4.887c0-.49.397-.887.887-.887h12.226c.49 0 .887.397.887.887v16.226c0 .49-.397.887-.887.887Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1h-1.51C13.52.377 12.78 0 12 0c-.781 0-1.52.377-1.99 1H8.5A1.5 1.5 0 007 2.5v3h10v-3A1.5 1.5 0 0015.5 1Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: "12",
    cy: "2.75",
    r: "1.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H8v.592c-.58.207-1 .757-1 1.408 0 .827.673 1.5 1.5 1.5a.5.5 0 010 1H7v1h1v.5h1v-.592c.58-.207 1-.757 1-1.408 0-.827-.673-1.5-1.5-1.5a.5.5 0 010-1H10v-1H9v-.5Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    x: "7",
    y: "8",
    width: "10",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    x: "12",
    y: "14",
    width: "5",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    x: "7",
    y: "11",
    width: "10",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    x: "12",
    y: "17",
    width: "5",
    height: "1"
  })));
}, {});